import React, { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import Header from "@/components/common/header/DefaultHeader";
import { getWebCMS } from '@/api/PDP';
import Footer from "@/components/common/footer/Footer";
import "./BuyersPremiumReduction.css";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const BuyersPremiumReduction = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const [cmsData, setCmsData] = useState('');
  useEffect(() => {
    getWebCMS("pages/buyersPremiumReduction").then((response) => {
      setCmsData(response?.results[0]);
    });
  }, []);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };
  return (
    <div>
      <Header />
      {/* First Section */}
      <div className="container-fluid p-0">
        <div className="row no-gutters">
          <div
            className="col-12 position-relative d-flex align-items-center"
            style={{
              height: "605px",
              paddingTop: "80px",
              backgroundPosition: "right top",
            }}
          >
            {!imageLoaded && (
              <div
                className="loader-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <TailSpin
                  height="80"
                  width="80"
                  color="#fff"
                  ariaLabel="loading"
                />
                <img
                  src="http://www.w3.org/1999/xlink"
                  alt="Logo"
                  className="img-fluid"
                  style={{ position: "absolute" }}
                />
              </div>
            )}
            <img
              src="/assets/images/staticPages/buyersPremiumReduction/buyers-premium-reduction-banner.png"
              alt="BuyersPremiumReduction"
              className="img-fluid w-100 h-100 position-absolute"
              style={{ objectFit: "cover", top: "0", left: "0", zIndex: "-1" }}
              onLoad={handleImageLoad}
            />
            <div
              className="container buyers-premium-container buyers-pre d-flex flex-column justify-content-center align-items-start text-white"
              style={{ zIndex: "1" }}
            >
              <h1 className="mb-3">{cmsData?.header}<br/> to Save!</h1>
              <h3 className="mb-3">Up to <span style={{ fontWeight: 700 }}>{cmsData?.subHeader1}</span><br /><span style={{ fontWeight: 700 }}>Premium </span>{cmsData?.subHeader2}</h3>
               <button className="btn btn-lg booking_btn btn-thm"><a href="/auctions?searchBy=All%20States&offers=buyers-premium-reduction&campaignId=7a8cb630-c6a1-4ebc-a85f-a0a4e8b07b69&campaignType=DYNAMIC" target="_blank">{cmsData?.btnText}</a></button>
            </div>
          </div>
        </div>
      </div>

      {/* Second Section */}
       <div className="container buyers-premium-container my-5">
      <div className="row g-5 align-items-start">
      {/*—Left column—*/}
      <div className="col-lg-6">
        <h1 className="bpr-fw-bold mb-3">
          Start your search now for a<br className="d-none d-md-inline" />
          chance to save big!
        </h1>
      <div className="buyers-pre">
        <p className="bpr-lead">
          Choose one of these select properties and you could reduce your
          Buyer&apos;s Premium by up to&nbsp;$2,000! These properties may not last
          long. Don&apos;t miss out on this opportunity to save big!
        </p>
        <button className="btn btn-lg booking_btn btn-thm">
          <a href="/auctions?searchBy=All%20States&offers=buyers-premium-reduction&campaignId=7a8cb630-c6a1-4ebc-a85f-a0a4e8b07b69&campaignType=DYNAMIC" target="_blank">{cmsData?.btnText}</a>
        </button>

        <p className="bpr-small text-muted mb-0">
          * The Buyer&#39;s Premium incentive will only be applicable if the
          terms of initial bid/offer are maintained by the buyer (this includes
          but is not limited to the original bid/offer, financing requirements,
          time to close, etc.) The Buyer&#39;s Premium reduction only applies to
          the auction cycle where you are the selected bidder and complete the
          transaction. In case you are the selected bidder and a fallout occurs,
          the Buyer&#39;s Premium reduction will not apply to any future
          transactions for the same property. The incentive will be credited
          toward your Buyer&#39;s Premium at time of contract execution.
        </p>
        </div>
      </div>

      {/* — Right column — */}
      <div className="col-lg-6">
         <div className="my-5">
      <table className="bpr-table-bordered text-center mb-0" style={{ width: "100%", fontSize: "1.1rem" }}>
        <thead>
          <tr className="border-0">
            <th colSpan={2} className="bpr-table-header border-0">Buyer&apos;s Premium reduced as follows:</th>
          </tr>
         <tr className="border-0">
        <th className="py-2 bpr-offer border-0">Selected Bid/<br className="d-none d-md-inline" />Offer Amount:</th>
          <th className="py-2 bpr-premium border-0">Amount Off<br className="d-none d-md-inline" />Buyer&apos;s Premium:</th>
        </tr>
        </thead>
        <tbody className="buyer-premium-table" >
          <tr className="bpr-table-row">
            <td>&lt;50K</td>
            <td>$500</td>
          </tr>
          <tr className="bpr-table-row">
            <td>50K to &lt;100K</td>
            <td>$750</td>
          </tr>
          <tr className="bpr-table-row">
            <td>100K to &lt;200K</td>
            <td>$1,000</td>
          </tr>
          <tr className="bpr-table-row">
            <td>200K to &lt;500K</td>
            <td>$1,500</td>
          </tr>
          <tr className="bpr-table-row">
            <td>
              500K <span className="bpr-fw-normal">or greater</span>
            </td>
            <td>$2,000</td>
          </tr>
        </tbody>
      </table>
    </div>
      </div>
    </div>
  </div>

      {/* Third section */}
      <div className="container-fluid p-0">
        <div className="row no-gutters">
          <div
            className="col-12 position-relative d-flex align-items-center"
            style={{
              height: "471px",
              paddingTop: "10px",
              backgroundPosition: "right top",
              margin: "25px auto",
            }}
          >
            {!imageLoaded && (
              <div
                className="loader-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <TailSpin
                  height="80"
                  width="80"
                  color="#fff"
                  ariaLabel="loading"
                />
                <img
                  src="http://www.w3.org/1999/xlink"
                  alt="Logo"
                  className="img-fluid"
                  style={{ position: "absolute" }}
                />
              </div>
            )}
            <img
              src="/assets/images/staticPages/buyersPremiumReduction/new-to-hubzu.png"
              alt="BuyersPremiumReduction"
              className="img-fluid w-100 h-100 position-absolute"
              style={{ objectFit: "cover", top: "0", left: "0", zIndex: "-1" }}
              onLoad={handleImageLoad}
            />
              <img
            src="/assets/images/staticPages/buyersPremiumReduction/newToHubzu-banner.png"               // or keep the string path
            alt="Person using laptop"
            className="d-none d-md-block position-absolute" /* hide on xs */
            style={{
              right: "10%",
              top: "15%",
              maxWidth: "435px",
              width: "40%",
              height: "auto",
              zIndex: 1,                       // above bg, below text
            }}
          />

          {/* ---------- TEXT / CTA ---------- */}
            <div
              className="container buyers-premium-container bpr-newtohubzu d-flex flex-column justify-content-center align-items-start text-white"
              style={{ zIndex: "1" }}
            >
              <h1 className="mb-3">{cmsData?.banner3?.header}</h1>
              <h3 className="mb-3">{cmsData?.banner3?.subHeader1}<br />{cmsData?.banner3?.subHeader2}</h3>
               <button className="btn btn-lg booking_btn newtohubzubtn"><a href="/auctions?searchBy=All%20States&offers=cash-incentive&campaignId=7602f038-74e6-4441-af7d-66e9146d5efd&campaignType=DYNAMIC" target="_blank">{cmsData?.btnText}</a></button>
            </div>
          </div>
        </div>
      </div>
      {/* footer */}
      {/* <section className="bpr_footer_one home6 bg-ptrn2">
        <div className="container buyers-premium-container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>
    </div>
  );
};

export default BuyersPremiumReduction;
